export default __webpack_public_path__ + "static/media/fa.js.42b58649.map";